import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Drawer, Select, Input } from 'antd';
import { RedoOutlined, PlusOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { RCTable, ButtonWrapper } from 'components';
import { ACL, FilterTitle } from 'components/common';
import { Box, Flex } from 'atoms';
import { getListAction } from 'store/pageSlice';
import { VehicleManagementTableConfig, initialPaginateConfig, VehicleListQueries } from 'utils';
import { useQueryParams } from 'hooks';

const { Search } = Input;

const LtSearchBar = styled(Search)`
	border: none;
`;

const StatusOptions = [
	{ value: true, label: 'Active' },
	{ value: false, label: 'Inactive' },
];

export default function VehicleManagementPage() {
	// const dispatch = useDispatch();
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);
	// const [vehicleTypeList, setVehicleTypeList] = useState('');
	const [rowData, setRowData] = useState({});
	const [paginateConfig, setpaginateConfig] = useQueryParams({
		search_type: 'vehicle',
		filterQuery: VehicleListQueries,
	});

	function redirectToEditPage(id) {
		navigate(`/vehicles/${id}`);
	}
	return (
		<>
			<Flex justifyContent="space-between" mt={3}>
				{/* <Box flex="0 0 35%">
					<SearchBar
						name="query_str"
						queryValue={paginateConfig?.query_str}
						onSearch={(val) =>
							setpaginateConfig({
								...initialPaginateConfig,
								query_str: val,
								search_type: 'vehicle',
							})
						}
					/>
				</Box> */}
				<Box flex="0 0 20%">
					<LtSearchBar
						enterButton="Search"
						placeholder="Search"
						allowClear
						onSearch={(val) =>
							setpaginateConfig({
								...initialPaginateConfig,
								query_str: val,
								search_type: 'vehicle',
							})
						}
					/>
				</Box>
				<Flex>
					<ButtonWrapper
						onClick={() =>
							setpaginateConfig({
								...initialPaginateConfig,
								search_type: 'vehicle',
							})
						}
						icons={<RedoOutlined />}
					>
						SYNC
					</ButtonWrapper>
					<ACL action="create" module="vehicle">
						<ButtonWrapper
							onClick={() => navigate('/vehicles/add')}
							icons={<PlusOutlined />}
						>
							CREATE
						</ButtonWrapper>
					</ACL>
				</Flex>
			</Flex>
			<Box mt={2}>
				<RCTable
					rowKey="id"
					tableDatas={[rowData, setRowData]}
					togglePaginate={[paginateConfig, setpaginateConfig]}
					dispatchAction={getListAction}
					columns={VehicleManagementTableConfig({
						redirectToEditPage,
					})}
				/>
			</Box>

			<Drawer
				className="userList-drawer"
				title={<FilterTitle onClose={() => setOpen(false)} />}
				placement="right"
				closable={false}
				onClose={() => setOpen(false)}
				open={open}
			>
				<Box>
					<Box marginBottom="2rem">
						<Box marginBottom="8px">Status</Box>
						<Select
							showSearch
							style={{ width: '100%' }}
							name="status"
							value={paginateConfig?.is_active}
							onChange={(val) =>
								setpaginateConfig((prev) => ({
									...prev,
									is_active: val,
								}))
							}
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Select"
							options={StatusOptions}
						/>
					</Box>
					{/* <Box marginBottom="2rem">
						<Box marginBottom="8px">Vehicle Type</Box>
						<Select
							showSearch
							style={{ width: '100%' }}
							name="vehicle_type"
							value={paginateConfig?.vehicle_type}
							onChange={(val) =>
								setpaginateConfig((prev) => ({
									...prev,
									vehicle_type: val,
								}))
							}
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							options={vehicleTypeList}
						/>
					</Box> */}
					<Box>
						{/* <ButtonWrapper
							marginLeft="auto"
							border="1px solid rgba(237, 108, 2, 0.5)"
							color="#ed6c02"
							onClick={() =>
								setpaginateConfig((prev) => ({
									...prev,
									user_type: 'admin',
								}))
							}
						>
							RESET FILTERS
						</ButtonWrapper> */}
						<ButtonWrapper
							marginLeft="auto"
							border="1px solid rgba(237, 108, 2, 0.5)"
							color="#ed6c02"
							onClick={() => {
								// navigate('/client-list');
								window.location = `${window.origin}/vehicles`;
							}}
						>
							RESET FILTERS
						</ButtonWrapper>
					</Box>
				</Box>
			</Drawer>
		</>
	);
}
